import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const GroupWrapper = styled.section(() => ({
    marginTop: "12px",
    ":first-of-type": {
        marginTop: 0,
    },
    ":last-of-type": {
        marginBottom: 0,
    },
}));

export const LimitReachedMessage = styled.div(props => ({
    display: "inline-block",
    boxSizing: "border-box",
    width: "100%",
    fontSize: props.theme.candy.typography.primary.fontSize.css(),
    padding: theme(props).size([0.5, 2.5]),
    color: theme(props).typography.secondary.color,
}));
